import { Component, effect, inject, Input } from '@angular/core';
import {
  ActiveUserState,
  ActiveUserStore,
  initialState,
} from '../../../stores/user/active-user.state';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Message } from 'primeng/api';
import { RouterLink } from '@angular/router';
import { getState } from '@ngrx/signals';
import { CardModule } from 'primeng/card';
import { Button } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';
import { NgIf } from '@angular/common';
import { AlertComponent } from '../../atoms/alert/alert.component';

@Component({
  selector: 'app-login-form',
  standalone: true,
  imports: [
    CardModule,
    ReactiveFormsModule,
    Button,
    RouterLink,
    DividerModule,
    MessagesModule,
    InputTextModule,
    NgIf,
    AlertComponent,
  ],
  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss',
})
export class LoginFormComponent {
  readonly store = inject(ActiveUserStore);
  @Input() redirect = false;

  loginForm: FormGroup;
  submitted = false;

  error: Message = {
    severity: 'error',
    summary: 'Login fehlgeschlagen',
    detail:
      '<p>Bitte prüfen Sie E-Mail-Adresse oder Anmeldename sowie das Passwort. Achten Sie auf Groß-/Kleinschreibung.</p>' +
      '<p><b>Tipp:</b> Wenden Sie sich bei Unsicherheiten an Ihre:n kommunale:n Administrator:in.</p>',
  };

  loading = false;
  state: ActiveUserState = initialState;
  messages: Message[] = [];

  constructor(private formBuilder: FormBuilder) {
    effect(() => {
      this.state = getState(this.store);
      if (this.state.error) {
        this.messages = [this.error];
      }
    });

    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  /**
   * Handles the form submission logic. Marks the form as submitted and retrieves form values.
   * If the form is invalid, the method terminates without proceeding further.
   * Otherwise, it triggers the login process with the provided credentials.
   *
   * @return {void} Does not return any value.
   */
  onSubmit(): void {
    this.submitted = true;
    const { username, password } = this.loginForm.value;

    if (this.loginForm.invalid) {
      return;
    }

    this.store.login({ username, password });
  }
}
